import React from 'react';
import { Grid, Box, Typography } from '@material-ui/core';

interface InputSectionProps {
  sm?:
    | boolean
    | 6
    | 12
    | 'auto'
    | 1
    | 2
    | 3
    | 4
    | 5
    | 7
    | 8
    | 9
    | 10
    | 11
    | undefined;
  xs?:
    | boolean
    | 6
    | 12
    | 'auto'
    | 1
    | 2
    | 3
    | 4
    | 5
    | 7
    | 8
    | 9
    | 10
    | 11
    | undefined;
  title?: string;
  children: React.ReactNode;
  titlePlaceholderPadding?: number;
  titlePadding?: number;
}

const LandingPageInputSection = (props: InputSectionProps) => {
  const {
    title = 'Section description',
    sm = 6,
    xs = 12,
    titlePlaceholderPadding = 6,
    titlePadding = 2,
    children,
  } = props;

  return (
    <Grid item sm={sm} xs={xs} container>
      <Grid item xs={12}>
        {title ? (
          <Box mb={titlePadding}>
            <Typography variant="h4" component="div">
              {title}
            </Typography>
          </Box>
        ) : (
          <Box mb={titlePlaceholderPadding} />
        )}
        {children}
      </Grid>
    </Grid>
  );
};

export default LandingPageInputSection;
